export const personal = [
  { key: 'full_name', label: 'Full name', required: true, hint: 'As on your documents', autoComplete: 'name' },
  { key: 'mobile', label: 'Mobile number', required: true, type: 'tel', maxLength: 10, autoComplete: 'tel' },
  { key: 'personal_email', label: 'Personal email', type: 'email', autoComplete: 'email' },
  { key: 'dob', label: 'Date of birth', type: 'date' },
  { key: 'birth_place', label: 'Place of birth' },
  { key: 'education', label: 'Highest education', options: ['10th / 12th', 'Graduate', 'Postgraduate', 'Professional', 'Other'] },
  { key: 'marital_status', label: 'Marital status', options: [['single', 'Unmarried'], ['married', 'Married'], ['other', 'Other']] },
  { key: 'spouse_name', label: "Spouse's full name", when: p => p.marital_status === 'married' },
  { key: 'children', label: 'Number of children', type: 'number', min: '0' },
  { key: 'dependants', label: 'Other dependants', type: 'number', min: '0' },
  { key: 'father_name', label: "Father's full name" },
  { key: 'mother_name', label: "Mother's full name" },
  { key: 'pan', label: 'PAN (optional)', maxLength: 10, hint: 'Only if you are comfortable sharing now' },
  { key: 'aadhaar', label: 'Aadhaar number (optional)', type: 'tel', maxLength: 12, hint: 'Only if needed for your loan; you may provide this later' },
  { key: 'religion', label: 'Religion (optional)' },
  { key: 'category', label: 'Category (optional)', options: [['general', 'General'], ['sc', 'SC'], ['st', 'ST'], ['obc', 'OBC'], ['minority', 'Minority'], ['other', 'Other']] },
];

export const residence = [
  { key: 'residence_type', label: 'Current residence', options: [['owned', 'Owned'], ['rented', 'Rented'], ['family', 'Family home'], ['other', 'Other']] },
  { key: 'current_address', label: 'Current full address', area: true },
  { key: 'current_years', label: 'Years at current address', type: 'number', min: '0', step: '0.5' },
  { key: 'permanent_address', label: 'Permanent full address', area: true, when: p => p.residence_type === 'rented' },
  { key: 'permanent_years', label: 'Years at permanent address', type: 'number', min: '0', step: '0.5', when: p => p.residence_type === 'rented' },
];

export const work = [
  { key: 'employment_status', label: 'Current work status', options: [['salaried', 'Salaried'], ['self_employed', 'Self-employed'], ['not_working', 'Not working'], ['retired', 'Retired']] },
  ...[
    { key: 'company_name', label: 'Company / office name' },
    { key: 'office_address', label: 'Office full address', area: true },
    { key: 'office_phone', label: 'Office phone', type: 'tel' },
    { key: 'experience_years', label: 'Total work experience (years)', type: 'number', min: '0', step: '0.5' },
    { key: 'joining_date', label: 'Date joined current company', type: 'date' },
    { key: 'official_email', label: 'Official email', type: 'email' },
    { key: 'designation', label: 'Designation' },
    { key: 'department', label: 'Department' },
    { key: 'business_nature', label: 'Nature of business / work' },
    { key: 'retirement_age', label: 'Expected retirement age', type: 'number', min: '0' },
  ].map(f => ({ ...f, when: p => ['salaried', 'self_employed'].includes(p.employment_status) })),
];

export const finance = [
  { key: 'has_loans', label: 'Any ongoing loans?', options: [['false', 'No'], ['true', 'Yes']], boolean: true },
  { key: 'loan_details', label: 'Bank, loan purpose and monthly EMI', area: true, when: p => p.has_loans },
  { key: 'has_investments', label: 'Any investments to mention?', options: [['false', 'No'], ['true', 'Yes']], boolean: true },
  { key: 'insurance', label: 'Insurance', when: p => p.has_investments },
  { key: 'mutual_funds', label: 'Mutual funds', when: p => p.has_investments },
  { key: 'shares', label: 'Shares', when: p => p.has_investments },
  { key: 'gold', label: 'Gold', when: p => p.has_investments },
  { key: 'pf', label: 'Provident fund (PF)', when: p => p.has_investments },
  { key: 'fd', label: 'Fixed deposits (FD)', when: p => p.has_investments },
];

export const loanFields = [
  { key: 'amount', label: 'Loan amount needed (₹)', type: 'number', min: '1' },
  { key: 'tenure_years', label: 'Preferred tenure (years)', type: 'number', min: '1', step: '0.5' },
  { key: 'property_type', label: 'Property purchase', options: [['resale', 'Resale'], ['builder', 'From builder'], ['not_decided', 'Not decided / not applicable']] },
  { key: 'property_address', label: 'Property address', area: true, when: p => ['resale', 'builder'].includes(p.property_type) },
];

export const allPersonFields = [...personal, ...residence, ...work, ...finance];
export const blankPerson = () => Object.fromEntries(allPersonFields.map(f => [f.key, f.boolean ? false : '']));
export const blankLoan = () => Object.fromEntries(loanFields.map(f => [f.key, '']));